<kendo-dialog [width]="1300" *ngIf="open" (close)="close()">
    <kendo-dialog-titlebar>
        <h3>{{'ADD-HOUSEHOLD-MEMBER' | translate}}</h3>
    </kendo-dialog-titlebar>
    <app-member-search [showHeader]="false" [addHouseholdMember]="true" [member]="member">
    </app-member-search>
    <kendo-dialog-actions>
        <form [formGroup]="householdForm">
            <div class="row" style="margin-bottom:-10px;">
                <div class="col-2 text-right" style="padding-top: 12px">
                    <span class="k-text-uppercase dark">
                        {{'RELATIONSHIP' | translate}} *
                    </span>
                </div>
                <div class="col-8">
                    <label class="k-form-field w-25">
                        <kendo-combobox id="relationship" formControlName="relationship" [data]="relationships"
                            [textField]="'displayName'" [valueField]="'id'" [valuePrimitive]="true"
                            (valueChange)="changeRelationship($event)">
                        </kendo-combobox>
                        <span class="k-tooltip k-tooltip-validation" role="alert" style="position: absolute;"
                            *ngIf="relationship.hasError('required') && relationship.touched">
                            {{'REQUIRED-RELATIONSHIP' | translate}}
                        </span>
                    </label>
                </div>
                <div class="col-2">
                    <button kendoButton type="button" (click)="close()" class="float-right">
                        {{ ('CLOSE') | translate}}
                    </button>
                </div>
            </div>
        </form>
    </kendo-dialog-actions>
</kendo-dialog>